import { Typography } from 'app/components/ui';
import { i18n } from 'app/utils/i18n';

export const NoDefaultWarning = () => (
  <Typography variant="body-3" color="#e07800" className="no-default-warning mt-1 mb-1">
    {i18n('tag.defaults.noProjectDefaults')}
  </Typography>
);
